// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../common/JQueryView';

export default class IndexView extends JQueryView {
  showModal: boolean;

  constructor(showModal: boolean) {
    super('.square-table');

    this.showModal = showModal;
    if (this.showModal) {
      $('#introduction_modal').modal('show');
    }
  }

  @on({ event: 'click', selector: 'tr[data-href]' })
  click(e: any) {
    $('.selected').removeClass('selected');
    const currentRow = $(e.currentTarget);
    currentRow.addClass('selected');

    const isLink = $(e.target).hasClass('link');
    if (isLink) return;
    $.ajax({
      url: $(e.currentTarget).data('href'),
      type: 'GET',
      dataType: 'script',
    });
  }

  @on({ event: 'click', selector: 'td[data-href]' })
  onClickTd(e: any) {
    const isLink = $(e.target).hasClass('link');
    if (isLink) return;
    $.ajax({
      url: $(e.currentTarget).data('href'),
      type: 'GET',
      dataType: 'script',
    });
  }
}
